'use client';

import { PortableTextBlock } from 'sanity';
import { PortableText } from 'next-sanity';
import { richTextComponent } from '@/sanity/sanityPortableText';
import { GROQImage } from '@/sanity/lib/definitions';
import ChipText from '@/components/global/ChipText';
import ComparisonTable from './ComparisonTable';

interface IBestChoiceProps {
  chipText: string;
  title: PortableTextBlock[];
  comparisonTable?: {
    columns: {
      name: string;
    }[];
    rows: {
      label: string;
      labelMobile: string;
      icon?: GROQImage;
      values: {
        type: 'check' | 'x' | 'text';
        text?: string;
      }[];
    }[];
  };
}

export default function BestChoice({
  chipText,
  title,
  comparisonTable,
}: IBestChoiceProps) {
  return (
    <section className="w-full flex flex-col items-center pt-[13rem] lg:pt-[17.5rem] pb-[5.5rem] lg:pb-[22.25rem]">
      <div className="container flex flex-col gap-[5rem] lg:gap-[12.75rem] items-center justify-center w-full">
        <div className="flex flex-col w-full items-center justify-center">
          {chipText &&
            <ChipText text={chipText} color="purple" />
          }
          <div className="richtext richtext-center prose-headings:text-[4.75rem] lg:prose-headings:text-[7.5rem] prose-headings:mb-[2.25rem] prose-p:text-[2rem] lg:prose-p:text-[2.5rem] prose-p:text-[#011410]/[64%]">
            <PortableText value={title} components={richTextComponent} />
          </div>
        </div>

        {/* Table */}
        {comparisonTable && (
          <div className="w-full">
            <ComparisonTable
              columns={comparisonTable.columns}
              rows={comparisonTable.rows}
            />
          </div>
        )}
      </div>
    </section>
  );
}
